export default "__VITE_ASSET__B5cr6RcW__"